<template>
	<div class="mainWrapper direct-purchase">
		<h1>Create Direct Purchase</h1>
		<div class="form" v-if="brands.length > 0">
			<div>
				<span class="label">BRAND</span>
				<b-autocomplete
					v-model="brandSuggestions"
					:data="filteredBrands"
					:open-on-focus="true"
					placeholder="Brand"
					field="name"
					@select="option => (selectedBrand = option)"
					class="brandAutocomplete"
					:disabled="products.length > 0"
				>
					<template slot="empty">No results found</template>
				</b-autocomplete>
			</div>

			<div v-if="selectedBrand">
				<span class="label">BD CODE / BARCODE</span>
				<div class="addDetails">
					<b-autocomplete
						:data="searchData"
						placeholder="BD Code"
						field="bd_code"
						@typing="searchProducts"
						@select="option => (product = option)"
						class="brandAutocomplete"
					>
						<template slot="empty">No results found</template>
					</b-autocomplete>
				</div>
			</div>

			<div v-if="product">
				<span class="label">ADD</span>
				<b-button type="is-info" icon-left="plus-circle-outline" @click="submit">ADD PRODUCT</b-button>
			</div>
		</div>

		<div class="list">
			<!-- v-if="products.length > 0" -->
			<div class="products-list header">
				<div>
					BD CODE
				</div>

				<div>
					BARCODE
				</div>

				<div>
					NAME
				</div>

				<div>
					RECEIVED DATE
				</div>

				<div>
					QUANTITY
				</div>

				<!-- <div>
					PRICE
				</div> -->

				<div>
					REMARK
				</div>
			</div>

			<div v-for="(item, index) of products" v-bind:key="index" class="products-list">
				<div>
					{{ item.bd_code }}
				</div>

				<div>
					{{ item.barcode }}
				</div>

				<div>
					{{ item.name }}
				</div>

				<div>
					<b-datepicker :date-formatter="dateFormatter" v-model="item.received_date" icon="calendar-today"> </b-datepicker>
				</div>

				<div>
					<input name="qtyInput" class="qtyInput" type="number" v-on:change="update(index, 'qty', $event.target.value)" />
				</div>

				<!-- <div>
					<input
						name="priceInput"
						class="priceInput"
						type="number"
						v-on:change="update(index, 'price', $event.target.value)"
					/>
				</div> -->

				<div>
					<textarea name="remark" class="remark" placeholder="Remark" v-model="item.remark" />
				</div>
			</div>
		</div>

		<div v-if="products.length > 0" class="detail-buttons-wrapper">
			<div></div>
			<div class="align-right">
				<button class="big-button" @click="save()">SAVE</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'AddDirectPurchase',
	data: function() {
		return {
			brands: [], // List of brands from API
			selectedBrand: null, // Selected brand
			bdcodeData: [], // API bdcode data
			searchData: [], // API Search data
			brandSuggestions: '', // List of brands
			product: null, // 1 selected product
			products: [], // Selected products
			name: null,
			supplier: null
		}
	},
	computed: {
		filteredBrands() {
			return this.brands.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.brandSuggestions.toLowerCase()) >= 0
				)
			})
		}
	},

	watch: {
		product: function(newData) {
			console.log(newData)
		},

		selectedBrand: function(newData) {
			this.product = null
			this.products = []
		}
	},

	mounted: async function() {
		// Get list of brands
		const data = {
			populate: ['suppliers']
		}

		const apiGetWarehouse = await this.$api.getWarehouse({ data })

		this.supplier = apiGetWarehouse.data.suppliers[0]._id

		// Get brands name which are related to this warehouse
		await Promise.all(
			apiGetWarehouse.data.suppliers[0].brand.map(async brand => {
				const brandData = {
					id: brand
				}

				const apiGetBrand = await this.$api.getBrand({ data: brandData })

				if (apiGetBrand !== undefined) {
					this.brands.push(apiGetBrand.data.list[0])
				}
			})
		)
	},

	methods: {
		save: async function() {
			var newData = []

			this.products.map(product => {
				var productData = {}
				productData.product = product._id
				productData.received_date = this.$moment(product.received_date).format('DD/MM/YYYY')
				productData.supplier = this.supplier
				// productData.price = product.price;
				productData.currency = 'MMK'
				productData.qty = product.qty
				productData.remark = product.remark

				newData.push(productData)
			})

			const data = {
				direct_purchase_items: newData
			}

			const apiSaveDP = await this.$api.saveDP({ data })

			if (apiSaveDP !== undefined) {
				this.$swal.fire(apiSaveDP.data.direct_purchase.code)

				this.$router.push('/direct-purchase')
			}
		},

		dateFormatter(dt) {
			return dt.toLocaleDateString('en-GB')
		},

		submit: async function() {
			this.product.received_date = null
			this.product.qty = null
			this.product.remark = null

			this.products.push(this.product)

			this.product = null
			this.searchData = []
		},

		update: function(index, item, value) {
			console.log(index, item, value)

			if (item == 'qty') {
				this.products[index].qty = Number(value)
			}

			// if (item == "price") {
			// 	this.products[index].price = Number(value);
			// }
		},

		// Autocomplete search
		searchProducts: async function(name) {
			if (name.length > 1) {
				const data = {
					brand: this.selectedBrand._id,
					bd_code: name
				}

				const apiSearchProduct = await this.$api.searchProduct({ data })

				this.searchData = apiSearchProduct.data.list

				// If no data found, try to search with barcode
				if (apiSearchProduct.data.list && apiSearchProduct.data.list.length < 1) {
					delete data.bd_code

					data.barcode = name

					const apiSearchProduct = await this.$api.searchProduct({ data })

					this.searchData = apiSearchProduct.data.list
				}
			}
		}
	}
}
</script>

<style scoped>
@import '../styles/AddDirectPurchase.css';
</style>
